/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { faqControllerCreate } from '../fn/faq/faq-controller-create';
import { FaqControllerCreate$Params } from '../fn/faq/faq-controller-create';
import { faqControllerDelete } from '../fn/faq/faq-controller-delete';
import { FaqControllerDelete$Params } from '../fn/faq/faq-controller-delete';
import { faqControllerFindAll } from '../fn/faq/faq-controller-find-all';
import { FaqControllerFindAll$Params } from '../fn/faq/faq-controller-find-all';
import { faqControllerFindById } from '../fn/faq/faq-controller-find-by-id';
import { FaqControllerFindById$Params } from '../fn/faq/faq-controller-find-by-id';
import { faqControllerSearch } from '../fn/faq/faq-controller-search';
import { FaqControllerSearch$Params } from '../fn/faq/faq-controller-search';
import { faqControllerTogglePinned } from '../fn/faq/faq-controller-toggle-pinned';
import { FaqControllerTogglePinned$Params } from '../fn/faq/faq-controller-toggle-pinned';
import { faqControllerUpdate } from '../fn/faq/faq-controller-update';
import { FaqControllerUpdate$Params } from '../fn/faq/faq-controller-update';
import { FaqDto } from '../models/faq-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class FaqService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `faqControllerSearch()` */
  static readonly FaqControllerSearchPath = '/api/v1/faq/search';

  /**
   * FAQ 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerSearch$Response(params: FaqControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return faqControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * FAQ 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerSearch(params: FaqControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.faqControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `faqControllerFindAll()` */
  static readonly FaqControllerFindAllPath = '/api/v1/faq';

  /**
   * 전체 FAQ 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerFindAll$Response(params?: FaqControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FaqDto>>> {
    return faqControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 전체 FAQ 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerFindAll(params?: FaqControllerFindAll$Params, context?: HttpContext): Observable<Array<FaqDto>> {
    return this.faqControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FaqDto>>): Array<FaqDto> => r.body)
    );
  }

  /** Path part for operation `faqControllerCreate()` */
  static readonly FaqControllerCreatePath = '/api/v1/faq';

  /**
   * FAQ 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqControllerCreate$Response(params: FaqControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    return faqControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * FAQ 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqControllerCreate(params: FaqControllerCreate$Params, context?: HttpContext): Observable<FaqDto> {
    return this.faqControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqControllerFindById()` */
  static readonly FaqControllerFindByIdPath = '/api/v1/faq/{id}';

  /**
   * FAQ 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerFindById$Response(params: FaqControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    return faqControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * FAQ 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerFindById(params: FaqControllerFindById$Params, context?: HttpContext): Observable<FaqDto> {
    return this.faqControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqControllerDelete()` */
  static readonly FaqControllerDeletePath = '/api/v1/faq/{id}';

  /**
   * FAQ 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerDelete$Response(params: FaqControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return faqControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * FAQ 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerDelete(params: FaqControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.faqControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `faqControllerUpdate()` */
  static readonly FaqControllerUpdatePath = '/api/v1/faq/{id}';

  /**
   * FAQ 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqControllerUpdate$Response(params: FaqControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    return faqControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * FAQ 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqControllerUpdate(params: FaqControllerUpdate$Params, context?: HttpContext): Observable<FaqDto> {
    return this.faqControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqControllerTogglePinned()` */
  static readonly FaqControllerTogglePinnedPath = '/api/v1/faq/{id}/pin';

  /**
   * FAQ 고정/고정해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerTogglePinned()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerTogglePinned$Response(params: FaqControllerTogglePinned$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    return faqControllerTogglePinned(this.http, this.rootUrl, params, context);
  }

  /**
   * FAQ 고정/고정해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerTogglePinned$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerTogglePinned(params: FaqControllerTogglePinned$Params, context?: HttpContext): Observable<FaqDto> {
    return this.faqControllerTogglePinned$Response(params, context).pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

}
